<h1 mat-dialog-title>{{"newOrder.hechtProposal.eccentricityModal.title" | translate}}</h1>

<div>
    <div class="d-flex">
        <ul class="input-parameters">
            <li *ngFor="let inputParameter of inputParametersMap | keyvalue">
                <h3 style="display:inline">{{inputParameter.key}}</h3>: {{inputParameter.value}}
            </li>
        </ul>
        <div class="d-flex circle">
            <div class="flex-grow-1"></div>
            <app-lens-side-circle [side]="side"></app-lens-side-circle>
        </div>
    </div>
    <form [formGroup]="form">
        <div class="d-flex">
            <label class="title-row-sagittal">{{"newOrder.hechtProposal.eccentricityModal.sagittalRadien" | translate}}</label>
            <div class="d-flex eccentricity-modal-parameter">
                <label>{{"common.features.Nasal" | translate}}
                    <input formControlName="nasal" class="form-control parameter-input" (blur)="setValueWithFormat('Nasal', 'nasal')"
                    [ngClass]="{required: true, error: form.get('nasal').errors && (form.get('nasal').touched || (form.get('nasal').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(5,15)" matTooltipPosition="above">
                </div>
            </div>

            <div class="d-flex eccentricity-modal-parameter">
                <label>{{"common.features.Temporal" | translate}}
                    <input formControlName="temporal" class="form-control parameter-input" (blur)="setValueWithFormat('Temporal', 'temporal')"
                    [ngClass]="{required: true, error: form.get('temporal').errors && (form.get('temporal').touched || (form.get('temporal').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(5,15)" matTooltipPosition="above">
                </div>
            </div>

            <div class="d-flex eccentricity-modal-parameter">
                <label>{{"common.features.Superior" | translate}}
                    <input formControlName="superior" class="form-control parameter-input" (blur)="setValueWithFormat('Superior', 'superior')"
                    [ngClass]="{required: true, error: form.get('superior').errors && (form.get('superior').touched || (form.get('superior').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(5,15)" matTooltipPosition="above">
                </div>
            </div>

            <div class="d-flex eccentricity-modal-parameter">
                <label>{{"common.features.Inferior" | translate}}
                    <input formControlName="inferior" class="form-control parameter-input" (blur)="setValueWithFormat('Inferior', 'inferior')"
                    [ngClass]="{required: true, error: form.get('inferior').errors && (form.get('inferior').touched || (form.get('inferior').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(5,15)" matTooltipPosition="above">
                </div>
            </div>

            <div class="d-flex eccentricity-modal-parameter">
                <label class="eccentricity-degree-label">{{"common.features.EccentricityDegree" | translate}}
                    <input formControlName="eccentricityDegree" class="form-control parameter-input"
                    [ngClass]="{required: true, error: form.get('eccentricityDegree').errors && (form.get('eccentricityDegree').touched || (form.get('eccentricityDegree').dirty))}"/>
                </label>
                <div class="info" style="margin-left: -35px;">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(15,35)" matTooltipPosition="above">
                </div>
            </div>
        </div>

        <div class="d-flex eccentricity-calc">
            <label class="title-row-eccentricity">{{"newOrder.hechtProposal.eccentricityModal.eccentricity" | translate}}</label>
            <div class="eccentricity-modal-parameter">
                <input formControlName="nasalCalc" class="form-control parameter-input" disabled/>
            </div>

            <div class="eccentricity-modal-parameter">
                <input formControlName="temporalCalc" class="form-control parameter-input" disabled/>
            </div>

            <div class="eccentricity-modal-parameter">
                <input formControlName="superiorCalc" class="form-control parameter-input" disabled/>
            </div>

            <div class="eccentricity-modal-parameter">
                <input formControlName="inferiorCalc" class="form-control parameter-input" disabled/>
            </div>

            <button mat-stroked-button style="min-width: 95px;" (click)="discard()">{{"newOrder.hechtProposal.eccentricityModal.button.discard" | translate}}</button>
            <button mat-stroked-button style="min-width: 95px;" (click)="calcFinalEccentricity()">{{"newOrder.hechtProposal.eccentricityModal.button.save" | translate}}</button>
        </div>

        <app-validation-error [form]="form"></app-validation-error>
    </form>
</div>